// A tiny wrapper around fetch(), borrowed from
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper
import Cookies from "js-cookie";

export async function client(path, { body, ...customConfig } = {}) {
  let endpoint = process.env.REACT_APP_SWURF_API_ENDPOINT
  const url = `${endpoint}${path}`

  const headers = {}
  if (body && !(body instanceof FormData))
    headers['Content-Type'] = 'application/json'

  const csrftoken = Cookies.get('csrftoken');
  if (csrftoken)
    headers['X-CSRFToken'] = csrftoken

  const config = {
    credentials: 'same-origin',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  }

  if (body) {
    if (body instanceof FormData)
      config.body = body
    else
      config.body = JSON.stringify(body)
  }

  let data
  try {
    const response = await window.fetch(url, config)
    data = await response.json()
    if (response.ok)
      return data

    console.log(`API error: ${response.status} (${response.statusText})\n${JSON.stringify(data)}`)
    return Promise.reject({response, data})
  } catch (err) {
    return Promise.reject(err.message ? err.message : data)
  }
}

client.get = function (endpoint, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: 'GET' })
}

client.post = function (endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'POST' })
}

client.put = function (endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'PUT' })
}

client.delete = function (endpoint, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: 'DELETE' })
}
